const CircleArrowRight03Icon = /*#__PURE__*/ [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.4966 9.4915C12.0279 10.0219 14.0065 11.3138 13.9966 12.0591C13.9166 12.797 11.9953 13.9749 11.4906 14.4952M6.99805 11.9751L13.9911 11.9835M16.9967 16.002L17.0063 8.00989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowRight03Icon as default };
//# sourceMappingURL=CircleArrowRight03Icon.js.map
